module.exports = __webpack_public_path__ + "static/media/icon_attachment.feb42144.png";